import {
  Login,
  PasswordDefine,
  PasswordRecoverRequest,
  PasswordRecoverReset,
  Register,
} from '../../pages/auth/_index.js';
import { AuthLayout } from '../../pages/auth/_layout.jsx';

export const authRoutes = {
  path: 'auth',
  element: <AuthLayout />,
  children: [
    { path: 'register', element: <Register /> },
    { path: 'setup/:tId', element: <PasswordDefine /> },
    { path: 'login', element: <Login /> },
    {
      path: 'password',
      children: [
        { path: 'recover', element: <PasswordRecoverRequest /> },
        { path: 'reset/:tId', element: <PasswordRecoverReset /> },
      ],
    },
  ],
};
